import Cookies from 'js-cookie';
import { apiClient } from 'shared/api-client';
import * as v from 'valibot';

import {
  getRegisterSourceData,
  type RegisterSourceData,
} from '../analytics/registerSource';

export const updateRegisterSource = async (data: RegisterSourceData) => {
  const { slug, ...custom_data } = data;
  return apiClient.post('bi/api/registersource/', {
    json: { slug, custom_data },
  });
};

export type GetLiveOffersUrlArgs = {
  webRecId: number;
  source: 'MY_SCOOPR' | 'LIVE_OFFERS_PREVIEW';
};

const LiveOffersUrlSchema = v.object({
  url: v.string(),
});

export const getLiveOffersUrl = async (args: GetLiveOffersUrlArgs) => {
  const res = await apiClient
    .get(
      `loans/applications/${args.webRecId}/g_live_offers_url/?source=${args.source}`,
    )
    .json();
  return v.parse(LiveOffersUrlSchema, res);
};

export const ExperimentVariantSchema = v.object({
  index: v.number(),
  experiment_id: v.string(),
  cookie: v.string(),
  cookie_name: v.string(),
});

export type ExperimentVariant = v.InferOutput<typeof ExperimentVariantSchema>;

export type GetExperimentVariantArgs = {
  id: string;
};

// Eating raw cookies is not healthy, but sometimes necessary
const rawCookies = Cookies.withConverter({
  read: (value) => value,
  write: (value) => value,
});

export const getExperimentVariant = async (
  args: GetExperimentVariantArgs,
): Promise<ExperimentVariant> => {
  const res = await apiClient
    .get(`optimize/experiments/${args.id}/get_variant/`)
    .json();

  const data = v.parse(ExperimentVariantSchema, res);

  rawCookies.set(data.cookie_name, data.cookie, {
    domain: '.scoopr.no',
    secure: true,
    sameSite: 'Strict',
    expires: 30,
  });
  void updateRegisterSource(getRegisterSourceData());

  return data;
};
